// src/service/paymentSchedule/PaymentScheduleService.ts
import {
  GetAgendaViewDataProps,
  GetCalendarDataProps,
  GetPaymentScheduleData,
} from "../../types/invoice.types";
import { get, post } from "../../utils/BaseService";

export async function getPaymentScheduleData(
  dispatch: any,
  props?: GetPaymentScheduleData
) {
  return await get(dispatch, "/invoices/getPaymentScheduleData", props);
}

export async function getPaymentSummary(dispatch: any) {
  return await get(dispatch, "/invoices/getPaymentSummary", null);
}

export async function getCalendarData(
  dispatch: any,
  props: GetCalendarDataProps
) {
  return await post(dispatch, "/invoices/getCalendarData", props);
}

export async function getAgendaViewData(
  dispatch: any,
  props: GetAgendaViewDataProps
) {
  return await post(dispatch, "/invoices/getAgendaViewData", props);
}

export async function getUpcomingPayments(dispatch: any, limit?: number) {
  return await get(
    dispatch,
    "/invoices/getUpcomingPayments",
    limit ? { limit } : null
  );
}

export async function getTimelineData(dispatch: any) {
  return await get(dispatch, "/invoices/getTimelineData", null);
}

export async function getFinancialProjections(dispatch: any) {
  return await get(dispatch, "/invoices/getFinancialProjections", null);
}